export const validation = {
  titleMaxChar: 100,
  subTitleMaxChar: 100,
  additionalParagraphMaxChar: 200
}
